













import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({
    name: 'icon-button',
})
export default class IconButton extends Vue {
    @Prop({ type: String, required: false })
    public title!: string;

    @Emit('click')
    click() {}
}
